import SnackbarProviderConnectionSynchronize from './SnackbarProviderConnectionSynchronize';
import SnackbarProviderConnectionSuccess from './SnackbarProviderConnectionSuccess';
import SnackbarProviderConnectionError from './SnackbarProviderConnectionError';
import SnackbarProviderConnectionVerify from './SnackbarProviderConnectionVerify';
import SnackbarProviderConnectionRequestOtp from './SnackbarProviderConnectionRequestOtp';
import SnackbarProviderConnectionCreationSuccess from './SnackbarProviderConnectionCreationSuccess';
import SnackbarProviderConnectionCreating from './SnackbarProviderConnectionCreating';
import SnackbarUpload from './SnackbarUpload';
import SnackbarUploadSuccess from './SnackbarUploadSuccess';
import SnackbarUploadError from './SnackbarUploadError';
import SnackbarError from './SnackbarError';
import SnackbarProcessing from './SnackbarProcessing';
import SnackbarProviderForecastPeriodicityRestore from './SnackbarProviderForecastPeriodicityRestore';
import SnackbarSuccess from './SnackbarSuccess';
import SnackbarInitAsyncProcess from './SnackbarInitAsyncProcess';
import SnackbarAutomateTagging from './SnackbarAutomateTagging';
import SnackbarUndo from './SnackbarUndo';

const VARIANT_COMPONENTS = {
    providerConnectionSynchronize: SnackbarProviderConnectionSynchronize,
    providerConnectionSuccess: SnackbarProviderConnectionSuccess,
    providerConnectionError: SnackbarProviderConnectionError,
    providerConnectionVerify: SnackbarProviderConnectionVerify,
    providerConnectionRequestOtp: SnackbarProviderConnectionRequestOtp,
    upload: SnackbarUpload,
    uploadSuccess: SnackbarUploadSuccess,
    uploadError: SnackbarUploadError,
    providerConnectionCreationSuccess: SnackbarProviderConnectionCreationSuccess,
    providerConnectionCreating: SnackbarProviderConnectionCreating,
    processing: SnackbarProcessing,
    forecastPeriodicityRestore: SnackbarProviderForecastPeriodicityRestore,
    success: SnackbarSuccess,
    error: SnackbarError,
    initAsyncProcess: SnackbarInitAsyncProcess,
    automateTagging: SnackbarAutomateTagging,
    undo: SnackbarUndo,
};

export default VARIANT_COMPONENTS;
